// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetAvailabilityResponse

import { hydrateWidgetProposal, type WidgetProposal, type WidgetProposalApiResponse } from './widgetProposal.gen';

export type WidgetAvailabilityApiResponse = {
	offers: Record<string, Record<string, Array<WidgetProposal>>>;
	memory: number | null;
};

export type WidgetAvailability = {
	offers: Record<string, Record<string, Array<WidgetProposal>>>;
	memory: number | null;
};

export function hydrateWidgetAvailability(data: WidgetAvailabilityApiResponse): WidgetAvailability {
	return {
		...data,
		offers: Array.isArray(data.offers) ? {} : data.offers,
	};
}